import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";

export const onRedirectBacklinksExactUrl: transitionHookFn = (transition) => {
    const params = transition.params();
    const { key, exactUrl }: Record<string, string | undefined> = params;

    if (!!key && !!exactUrl && exactUrl.includes(key)) {
        return {
            params: {
                ...params,
                exactUrl: null,
            },
        };
    }

    return void 0;
};
